import { call, put, take, takeLatest, select } from "redux-saga/effects";

import types from "./types";
import api from "./api";
import actions from "./actions";

export function* get_products(action) {
  // const {username, password} = action.payload;

  try {
    const { data } = yield api.get_products();

    yield put(
      actions.set_products({
        products: data,
      })
    );

    return data;
  } catch (err) {
    // const error_messages = response_error(err, resources);

    // error_messages.forEach(message => toast.error(message));
    console.log("error", err);

    // yield put(actions.login_failed());

    return false;
  }
}

export default [takeLatest(types.GET_PRODUCTS_REQUEST, get_products)];
